import React from 'react';

const NOTE_STYLE = {
    padding: '10px 12px',
    backgroundColor: '#fffbeb',
    border: '1px solid #fcd34d',
    borderRadius: '8px',
    textAlign: 'left',
    fontSize: '13px',
    color: '#78350f',
    lineHeight: 1.5,
};

/**
 * A file that states no day of its own. The owner's rule: warn, and the TSR still goes
 * through. So there is no choice to make here, only OK.
 */
export function NoDateFileWarning({ files, dateLabel, onClose }) {
    if (!Array.isArray(files) || files.length === 0) return null;
    const several = files.length > 1;
    return (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                <div className="modal-header">
                    <h2 style={{ color: '#000', textAlign: 'center', flex: 1, margin: '20px 20px 0 20px', fontSize: '1.3rem', fontWeight: 700 }}>
                        {several ? 'These files have no date' : 'This file has no date'}
                    </h2>
                </div>
                <div className="modal-body" style={{ padding: '16px 20px 12px 20px' }}>
                    <p style={{ ...NOTE_STYLE, marginBottom: '12px', fontSize: '14px' }}>
                        We could not check that it is for {dateLabel}. You can still file it for {dateLabel}, so please make sure that is the right day.
                    </p>
                    <ul style={{ margin: 0, paddingLeft: '18px', color: '#374151', fontSize: '13px', textAlign: 'left' }}>
                        {files.map((name) => <li key={name}>{name}</li>)}
                    </ul>
                </div>
                <div className="modal-footer" style={{ display: 'flex', padding: '10px 20px 20px 20px' }}>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{ flex: 1, padding: '12px 24px', backgroundColor: '#000', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '15px' }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}

/**
 * Under the date option, before they file: a closing count already holds this date's
 * stock, and/or a TSR filed for it could never be reverted.
 */
export function CountedDateNote({ countDateLabel, noRevert }) {
    if (!countDateLabel && !noRevert) return null;
    return (
        <div role="note" style={NOTE_STYLE}>
            {countDateLabel && `The closing count of ${countDateLabel} already includes this date. Sales will be recorded, but stock will not be deducted. `}
            {noRevert && 'A TSR filed for this date cannot be reverted later.'}
        </div>
    );
}

/** In the success popup: what that filing did. */
export function StockAbsorbedNote({ countDateLabel }) {
    if (!countDateLabel) return null;
    return (
        <div style={{ ...NOTE_STYLE, margin: '0 0 16px' }}>
            Stock was not deducted: the closing count of {countDateLabel} already includes this date.
        </div>
    );
}
